import { useQuery } from '@tanstack/react-query';
import { fetchShipmentCategoryType } from '../../data-provider/select-options';
import type { GetShipmentCategoryTypeRequestParams } from '../../data-provider/select-options/shipment-category-type/api';

export const useGetShipmentCategoryType = (params: GetShipmentCategoryTypeRequestParams) => {
  return useQuery({
    queryKey: ['shipment-category-type-list', params.CustomerKey],
    queryFn: () => fetchShipmentCategoryType(params),
    enabled: !!params.CustomerKey,
    staleTime: 1000 * 60 * 60, // 1 hour
  });
};
